import Modal from "../../components/Modal";

const DownloadDpModal = ({ userName, event, image, open, onClose, onDownload, onReset }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Hi ${userName}, you're attending ${event.title}!`}
      subtitle="You have successfully created your DP, you can now download and share on your social media platforms."
      ctaBtns={{
        primary: { text: 'Download Banner', onClick: onDownload },
        secondary: { text: 'Start Over', onClick: onReset },
      }}>
      <div className="mt-8 mx-8 bg-gray-200">
        <img
          src={image}
          alt="generated dp"
        />
      </div>
    </Modal>
  )
};

export default DownloadDpModal;
